import { joinFormDataPath } from "../utils/formPaths";

const ABSOLUTE_FIELD_PATHS: Record<string, string> = {
  POLICY_NAME: "policy.name",
  POLICY_DESCRIPTION: "policy.description",
  POLICY_TYPE: "policy_type",
  RULE_NAME: "name",
  RULE_DESCRIPTION: "description",
  RULE_CATEGORY: "rule_category",
  RULE_ENFORCEMENT_MODE: "enforcement_mode",
  RULE_STATUS: "is_active",
  RULE_DEFINITION_OPERATOR: "rule_definition.operator",
};

const HIDDEN_POLICY_FORM_FIELD_KEYS = new Set(["POLICY_TYPE"]);

const RULE_CARD_HIDDEN_FIELD_KEYS = new Set(["RULE_CATEGORY"]);

export function isHiddenPolicyFormField(fieldKey: string): boolean {
  return HIDDEN_POLICY_FORM_FIELD_KEYS.has(fieldKey);
}

export function isRuleCardHiddenField(fieldKey: string): boolean {
  return RULE_CARD_HIDDEN_FIELD_KEYS.has(fieldKey);
}

const RELATIVE_FIELD_PATHS: Record<string, string> = {
  GROUP_OPERATOR: "operator",
  CONDITION_FIELD_KEY: "title",
  CONDITION_OPERATOR: "operator",
  CONDITION_VALUE: "value",
  CONDITION_VALUE_TYPE: "value_type",
};

const POLICY_OPERATOR_FIELD_KEYS = new Set<string>([
  "RULE_DEFINITION_OPERATOR",
  "GROUP_OPERATOR",
  "CONDITION_OPERATOR",
]);

export function isPolicyOperatorFieldKey(fieldKey: string): boolean {
  return POLICY_OPERATOR_FIELD_KEYS.has(fieldKey);
}

export function resolveFieldDataPath(
  fieldKey: string,
  builderField: string,
  parentDataPath: string,
): string {
  if (RELATIVE_FIELD_PATHS[fieldKey]) {
    return RELATIVE_FIELD_PATHS[fieldKey];
  }

  if (ABSOLUTE_FIELD_PATHS[fieldKey]) {
    return ABSOLUTE_FIELD_PATHS[fieldKey];
  }

  return joinFormDataPath(parentDataPath, builderField);
}
